import PropTypes from 'prop-types';
import React, {Component} from 'react';

import LoadingGif from '../../static/img/loading/loading.gif';

const propTypes = {
    style: PropTypes.object
};

class Loading extends Component {
    render() {
        return (
            <div className="loading-container" style={this.props.style}>
                <div className="loading-container_overlay">
                    <div className="loading-container_loading">
                        <img alt="" src={LoadingGif} />
                    </div>
                </div>
            </div>
        )
    }
}

Loading.propTypes = propTypes;

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Base/Loading.js